import React from 'react';
import { components, GroupBase, MenuListProps } from 'react-select';

import { PaginatedSentinelStyled, PaginatedErrorStyled, PaginatedRetryStyled } from './styles';

export interface PaginatedMenuState {
  loading: boolean;
  error: Error | null;
  hasMore: boolean;
  onRetry: () => void;
  labels: {
    loading: string;
    error: string;
    retry: string;
  };
}

interface SelectPropsWithPagination {
  paginatedState?: PaginatedMenuState;
}

function PaginatedSelectMenu<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: MenuListProps<Option, IsMulti, Group>) {
  const state = (props.selectProps as SelectPropsWithPagination).paginatedState;

  return (
    <components.MenuList {...props}>
      {props.children}
      {state?.loading && (
        <PaginatedSentinelStyled role="status" aria-live="polite">
          {state.labels.loading}
        </PaginatedSentinelStyled>
      )}
      {state?.error && !state.loading && (
        <PaginatedErrorStyled role="alert">
          <span>{state.labels.error}</span>
          <PaginatedRetryStyled
            type="button"
            onMouseDown={(e) => e.preventDefault()}
            onClick={state.onRetry}
          >
            {state.labels.retry}
          </PaginatedRetryStyled>
        </PaginatedErrorStyled>
      )}
    </components.MenuList>
  );
}

export default PaginatedSelectMenu;
